'use client';

/**
 * PremiumExperienceCategories — sezione #esperienze in home premium.
 *
 * Variante unica: Tabs (tab tipologia top + grid card sotto).
 */

import { useExperiencesCatalog } from './catalog-variants/shared';
import CatalogVariantTabs from './catalog-variants/CatalogVariantTabs';

export default function PremiumExperienceCategories({ types }: { types?: string } = {}) {
  const data = useExperiencesCatalog(types);
  return <CatalogVariantTabs data={data} />;
}
